import { createReducer } from "@reduxjs/toolkit";
import {
  FETCH_AVAILABILITY_TYPES_SUCCESS,
  ADD_AVAILABILITY_TYPE_SUCCESS,
  EDIT_AVAILABILITY_TYPE_SUCCESS,
  DELETE_AVAILABILITY_TYPE_SUCCESS,
  EDIT_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
  ADD_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
  DELETE_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
} from "~/store/action_types";

const reducer = createReducer({}, (builder) => {
  builder
    .addCase(FETCH_AVAILABILITY_TYPES_SUCCESS, (state, action) => {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { availability_types } = entities;
      if (availability_types) {
        state = availability_types;
      }
      return state;
    })
    .addMatcher(
      (action) =>
        [
          ADD_AVAILABILITY_TYPE_SUCCESS,
          EDIT_AVAILABILITY_TYPE_SUCCESS,
          ADD_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
          EDIT_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS,
        ].includes(action.type),
      (state, action) => {
        const { response = {} } = action;
        const { entities = {} } = response;
        const { availability_types = {} } = entities;
        if (availability_types) {
          state = {
            ...state,
            ...availability_types,
          };
        }
        return state;
      }
    )
    .addMatcher(
      (action) =>
        [DELETE_AVAILABILITY_TYPE_FROM_EVENT_STREAM_SUCCESS, DELETE_AVAILABILITY_TYPE_SUCCESS].includes(action.type),
      (state, action) => {
        const { id } = action;
        if (id) {
          const { [id]: _deleted, ...rest } = state;
          return rest;
        }
        return state;
      }
    );
});

export default reducer;
